import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-320a1938"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningTextBlock',
  props: {
    modelValue: null
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click', $event))),
    class: "validation-error"
  }, [
    _createElementVNode("img", {
      src: "/images/alert.svg",
      alt: __props.modelValue
    }, null, 8, _hoisted_1),
    _createElementVNode("p", null, _toDisplayString(__props.modelValue), 1)
  ]))
}
}

})